//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EsQuery from "@/javascript/esQuery";
import util from "@/javascript/util";

import Cpts003 from "@/components/public-components/cpts003/index";
import { formatDate } from "@/javascript/formatDate";

export default {
  components: {
    Cpts003,
  },
  data() {
    return {
      minHeight: 0,
      placeholder: "搜索景区\\攻略\\游记\\酒店\\美食",
      value: "",
      hotList: [],
      tabs: ["综合", "景区", "攻略", "游记", "酒店", "美食", "新闻", "公告","自驾营地","农家乐"],
      tabCur: 0,
      searchResult: false,
      scenicList: [],
      strategyList: [],
      travelsList: [],
      foodList: [],
      countryList: [],
      tabsList: [],
      tabsListPageNo: 0,
      tabsListPageSize: 10,
      infiniteStatus: false,
      infiniteAll: false,
      hotelLists: [],
      newsList: [],
      notifyList: [],
      selfList:[],
      drivList:[],
      agrList:[]
    };
  },
  filters: {
    // 格式化时间戳
    formatDate(datestamp) {
      if (datestamp != null) {
        let result = new Date(Number(datestamp));
        const y = result.getFullYear();
        let m = result.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = result.getDate();
        d = d < 10 ? "0" + d : d;
        let h = result.getHours();
        h = h < 10 ? "0" + h : h;
        let n = result.getMinutes();
        n = n < 10 ? "0" + n : n;
        let s = result.getSeconds();
        s = s < 10 ? "0" + s : s;
        return `${y}-${m}-${d} ${h}:${n}`;
      }
    },
  },
  mounted() {
    document.title = this.PAGE_TITLE + "搜索";
    const _this = this;

    this.minHeight = document.documentElement.clientHeight;

    _this.searchType = _this.$route.query.type ? parseInt(_this.$route.query.type) : 0;
    /**
     * 热搜景区列表
     */
    const querystring = require("querystring");
    switch (_this.searchType) {
      case 1: // 景区
        console.log("景区");

        const scenicEsQuery = new EsQuery();
        scenicEsQuery
          .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, scenicEsQuery.and, false)
          .addPattern("title.keyword", "*" + _this.value + "*", scenicEsQuery.and, false)
          .addSort("weight", scenicEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);

        if (_this.$route.query.code) {
          scenicEsQuery.addString(
            "category",
            _this.$route.query.code,
            scenicEsQuery.and,
            false
          );
        } else {
          scenicEsQuery.addString(
            "category",
            _this.XXCJ_TYPE_CODE.JQ,
            scenicEsQuery.and,
            false
          );
        }

        const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.scenic,
              esJsonQuery: scenicEsJsonQuery,
            })
          )
          .then((response) => {
            this.hotList = response.data.data;
          });
        break;
      case 2: // 攻略
        console.log("攻略");
        const strategyEsQuery = new EsQuery();
        strategyEsQuery
          .addPattern(
            "title.keyword",
            "*" + _this.value + "*",
            strategyEsQuery.and,
            false
          )
          // .addPattern("tags", _this.value, strategyEsQuery.or, false)
          .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, strategyEsQuery.and, false)
          .addString("kind", "1", strategyEsQuery.and, false)
          // .addSort("sortNum", strategyEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        const strategyEsJsonQuery = JSON.stringify(strategyEsQuery.getArray());
        _this.$http
          .post(
            "api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.strList,
              esJsonQuery: strategyEsJsonQuery,
            })
          )
          .then((response) => {
            this.hotList = response.data.data;
          });
        break;
      case 3: // 游记
        _this.placeholder = "搜索游记";
        const travelsEsQuery = new EsQuery();
        travelsEsQuery
          .addPattern("title.keyword", "*" + _this.value + "*", travelsEsQuery.and, false)
          .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, travelsEsQuery.and, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.travelList,
              esJsonQuery: travelsEsJsonQuery,
            })
          )
          .then((response) => {
            this.hotList = response.data.data;
          });
        break;

      case 4: // 酒店
        const hotelEsQuery = new EsQuery();
        hotelEsQuery
          // .addString("category", _this.XXCJ_TYPE_CODE.JD, hotelEsQuery.and, false)
          .addPattern("title.keyword", "*" + _this.value + "*", hotelEsQuery.and, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize)
          // .addSort("level", hotelEsQuery.asc, false)
          .addString("deptCode", this.DEPT_CODE.DEPTCODE, hotelEsQuery.and, false);
        const hotelEsJsonQuery = JSON.stringify(hotelEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.hotelList,
              esJsonQuery: hotelEsJsonQuery,
            })
          )
          .then((response) => {
            this.hotList = response.data.data;
          });
        break;
      case 5: // 美食
        const allXcEsQuery = new EsQuery();
        allXcEsQuery
          .addString("category", _this.XXCJ_TYPE_CODE.MS, allXcEsQuery.and, false)
          .addPattern("title.keyword", "*" + this.value + "*", allXcEsQuery.and, false)
          // .addSort("weight", allXcEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize)
          .addString("deptCode", this.DEPT_CODE.DEPTCODE, allXcEsQuery.and, false);
        const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.periphery,
              esJsonQuery: allXcEsJsonQuery,
            })
          )
          .then((response) => {
            this.hotList = response.data.data;
          });
        break;
      case 6: // 新闻
        let newsEsQuery = new EsQuery();
        newsEsQuery
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
          .addStartWith("catalogCode", "00000000,1720488224033", newsEsQuery.and, false)
          // .addString("top", 1, newsEsQuery.and, false)
          .addSort("title.keyword", newsEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        let newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.newsList,
              esJsonQuery: newsEsJsonQuery,
            })
          )
          .then(function (response) {
            _this.hotList = response.data.data;
          });
        break;
      case 7: // 公告
        newsEsQuery = new EsQuery();
        newsEsQuery
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
          .addStartWith("catalogCode", this.$route.query.code, newsEsQuery.and, false)
          // .addString("top", 1, newsEsQuery.and, false)
          .addSort("title.keyword", newsEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.newsList,
              esJsonQuery: newsEsJsonQuery,
            })
          )
          .then(function (response) {
            _this.hotList = response.data.data;
          });
        break;
      case 8: // 自驾营地
        newsEsQuery = new EsQuery();
        newsEsQuery
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
          .addSort("title.keyword", newsEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.driveCamp,
              esJsonQuery: newsEsJsonQuery,
            })
          )
          .then(function (response) {
            _this.hotList = response.data.data;
          });
        break;
      case 9: // 农家乐
        newsEsQuery = new EsQuery();
        newsEsQuery
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
          .addSort("title.keyword", newsEsQuery.desc, false)
          .addPage(_this.tabsListPageNo * _this.tabsListPageSize, _this.tabsListPageSize);
        newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
        _this.$http
          .post(
            "/api/wtcp-kb/pub/doc/search",
            querystring.stringify({
              indexName: _this.INDEX_NAME_TYPE.rural,
              esJsonQuery: newsEsJsonQuery,
            })
          )
          .then(function (response) {
            _this.hotList = response.data.data;
          });
        break;
      default:
        break;
    }

    /**
     * 底部加载
     */
    window.addEventListener("scroll", () => {
      if (util.pullUpLoad() && this.tabCur != 0) {
        this.infinite();
      }
    });
  },
  methods: {
    closePopup: function () {
      this.$router.go(-1);
    },
    clearValue: function () {
      this.value = "";
      this.searchResult = false;
    },
    searchFun: function () {
      if (this.value) {
        this.searchResult = true;

        this.getScenicList();
        this.getStrategyList();
        this.getTravelsList();
        // this.getCountryList()
        this.getHotelList();
        this.initTabsList();
        this.getFoodList();
        this.getNewsList();
        this.getNotifyList();
        this.getagrList()
        this.getdrivList()
      }
    },
    getScenicList: function () {
      const querystring = require("querystring");
      const scenicEsQuery = new EsQuery();
      scenicEsQuery
        // .addString("category", this.XXCJ_TYPE_CODE.JQ, scenicEsQuery.and, false)
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, scenicEsQuery.and, false)
        .addPattern("title.keyword", "*" + this.value + "*", scenicEsQuery.and, false)
        .addSort("weight", scenicEsQuery.desc, false)
        .addPage(0, 2);
      const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray());
      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: this.INDEX_NAME_TYPE.scenic,
            esJsonQuery: scenicEsJsonQuery,
          })
        )
        .then((response) => {
          console.log(response, "responseresponse");
          this.scenicList = response.data.data;
          // console.log('scenicList...', this.scenicList);
        });
    },
    getStrategyList: function () {
      const _this = this;
      const querystring = require("querystring");
      const strategyEsQuery = new EsQuery();
      console.log(strategyEsQuery, "strategyEsQuerystrategyEsQuery");
      strategyEsQuery
        .addPattern("title.keyword", "*" + _this.value + "*", strategyEsQuery.and, false)
        // .addPattern("tags", _this.value, strategyEsQuery.or, false)
        .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, strategyEsQuery.and, false)
        .addString("kind", "1", strategyEsQuery.and, false)
        // .addSort("sortNum", strategyEsQuery.desc, false)
        .addPage(0, 2);
      const strategyEsJsonQuery = JSON.stringify(strategyEsQuery.getArray());
      _this.$http
        .post(
          "api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: _this.INDEX_NAME_TYPE.strList,
            esJsonQuery: strategyEsJsonQuery,
          })
        )
        .then(function (response) {
          if (response.data.data.length > 0) {
            _this.strategyList = response.data.data;
          } else {
            const strategyEsQueryTags = new EsQuery();
            strategyEsQueryTags
              .addPattern("tags", "*" + _this.value + "*", strategyEsQueryTags.and, false)
              // .addPattern("tags", _this.value, strategyEsQuery.or, false)
              .addStartWith(
                "deptCode",
                _this.DEPT_CODE.DEPTCODE,
                strategyEsQueryTags.and,
                false
              )
              .addString("kind", "1", strategyEsQueryTags.and, false)
              .addPage(0, 2);
            const strategytagsJsonQuery = JSON.stringify(strategyEsQueryTags.getArray());
            _this.$http
              .post(
                "api/wtcp-kb/pub/doc/search",
                querystring.stringify({
                  indexName: _this.INDEX_NAME_TYPE.strList,
                  esJsonQuery: strategytagsJsonQuery,
                })
              )
              .then(function (response) {
                _this.strategyList = response.data.data;
              });
          }
          // console.log('_this.strategyList', _this.strategyList);
        });
    },
    getTravelsList: function () {
      const querystring = require("querystring");
      const travelsEsQuery = new EsQuery();
      travelsEsQuery
        .addPattern("title.keyword", "*" + this.value + "*", travelsEsQuery.and, false)
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, travelsEsQuery.and, false)
        .addPage(0, 2);
      const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray());
      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: this.INDEX_NAME_TYPE.travelList,
            esJsonQuery: travelsEsJsonQuery,
          })
        )
        .then((response) => {
          this.travelsList = response.data.data;
        });
    },
    getCountryList: function () {
      const querystring = require("querystring");
      const countryEsQuery = new EsQuery();
      countryEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, countryEsQuery.and, false)
        .addPattern("title.keyword", "*" + this.value + "*", countryEsQuery.and, false)
        .addSort("weight", countryEsQuery.desc, false)
        .addPage(0, 2);
      const countryEsJsonQuery = JSON.stringify(countryEsQuery.getArray());
      this.$http
        .get(
          "/bicQuery?indexName=" +
            this.INDEX_NAME_TYPE.rural +
            "&esJsonQuery=" +
            encodeURI(countryEsJsonQuery)
        )
        .then((response) => {
          this.countryList = response.data.data;
        });
    },
    getHotelList: function () {
      const querystring = require("querystring");
      const hotelEsQuery = new EsQuery();
      hotelEsQuery
        //   .addPattern("category", this.XXCJ_TYPE_CODE.JD, hotelEsQuery.and, false)
        .addPattern("title.keyword", "*" + this.value + "*", hotelEsQuery.and, false)
        .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
        // .addSort("level", hotelEsQuery.asc, false)
        .addString("deptCode", this.DEPT_CODE.DEPTCODE, hotelEsQuery.and, false);
      const hotelEsJsonQuery = JSON.stringify(hotelEsQuery.getArray());
      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: this.INDEX_NAME_TYPE.hotelList,
            esJsonQuery: hotelEsJsonQuery,
          })
        )
        .then((response) => {
          this.hotelLists = response.data.data;
        });
    },
    getFoodList: function () {
      // 小吃
      const querystring = require("querystring");
      const allXcEsQuery = new EsQuery();
      const _this = this;
      allXcEsQuery
        .addString("category", this.XXCJ_TYPE_CODE.MS, allXcEsQuery.and, false)
        .addPattern("title.keyword", "*" + this.value + "*", allXcEsQuery.and, false)
        // .addSort("weight", allXcEsQuery.desc, false)
        .addString("deptCode", this.DEPT_CODE.DEPTCODE, allXcEsQuery.and, false)
        .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize);
      const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray());
      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: this.INDEX_NAME_TYPE.periphery,
            esJsonQuery: allXcEsJsonQuery,
          })
        )
        .then(function (res) {
          _this.foodList = res.data.data;
        });
    },
    //资讯
    getNewsList: function () {
      const _this = this;
      const querystring = require("querystring");
      const newsEsQuery = new EsQuery();
      newsEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
        .addStartWith("catalogCode", "00000000,1720488224033", newsEsQuery.and, false)
        // .addString("top", 1, newsEsQuery.and, false)
        .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
        .addSort("weight", newsEsQuery.desc, false)
        .addPage(0, 2);
      const newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
      _this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: _this.INDEX_NAME_TYPE.newsList,
            esJsonQuery: newsEsJsonQuery,
          })
        )
        .then(function (response) {
          _this.newsList = response.data.data;
        });
    },
    //公告
    getNotifyList: function () {
      const _this = this;
      const querystring = require("querystring");
      const newsEsQuery = new EsQuery();
      newsEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
        .addStartWith("catalogCode", "00000000,1720766038703", newsEsQuery.and, false)
        // .addString("top", 1, newsEsQuery.and, false)
        .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
        .addSort("weight", newsEsQuery.desc, false)
        .addPage(0, 2);
      const newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
      _this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: _this.INDEX_NAME_TYPE.newsList,
            esJsonQuery: newsEsJsonQuery,
          })
        )
        .then(function (response) {
          _this.notifyList = response.data.data;
        });
    },
    // 自驾营地
    getdrivList: function () {
      const _this = this;
      const querystring = require("querystring");
      const newsEsQuery = new EsQuery();
      newsEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
        .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
        .addSort("weight", newsEsQuery.desc, false)
        .addPage(0, 2);
      const newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
      _this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: _this.INDEX_NAME_TYPE.driveCamp,
            esJsonQuery: newsEsJsonQuery,
          })
        )
        .then(function (response) {
          console.log(response.data.data,'drivList自驾游');
         _this.drivList=response.data.data
        });
    },
    // 农家乐
    getagrList: function () {
      const _this = this;
      const querystring = require("querystring");
      const newsEsQuery = new EsQuery();
      newsEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
        .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
        .addSort("weight", newsEsQuery.desc, false)
        .addPage(0, 2);
      const newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
      _this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring.stringify({
            indexName: _this.INDEX_NAME_TYPE.rural,
            esJsonQuery: newsEsJsonQuery,
          })
        )
        .then(function (response) {
          _this.agrList=response.data.data
        });
    },
    // getNotifyList: function () {
    //   const _this = this;
    //   const querystring = require("querystring");
    //   const newsEsQuery = new EsQuery();
    //   newsEsQuery
    //     .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
    //     .addStartWith("catalogCode", "00000000,1720766038703", newsEsQuery.and, false)
    //     // .addString("top", 1, newsEsQuery.and, false)
    //     .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
    //     .addSort("weight", newsEsQuery.desc, false)
    //     .addPage(0, 2);
    //   const newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
    //   _this.$http
    //     .post(
    //       "/api/wtcp-kb/pub/doc/search",
    //       querystring.stringify({
    //         indexName: _this.INDEX_NAME_TYPE.newsList,
    //         esJsonQuery: newsEsJsonQuery,
    //       })
    //     )
    //     .then(function (response) {
    //       _this.notifyList = response.data.data;
    //     });
    // },
    tabChange: function (index) {
      this.tabCur = index;
      this.initTabsList();
    },
    initTabsList: function () {
      this.tabsListPageNo = 0;
      this.infiniteAll = false;
      this.infiniteStatus = true;
      this.tabsList = [];

      if (this.tabCur == 0) {
        this.infiniteStatus = false;
      }

      this.getTabsList();
    },
    getTabsList: function () {
      const _this = this;
      const querystring = require("querystring");
      switch (_this.tabCur) {
        case 1: // 景区
          const scenicEsQuery = new EsQuery();
          scenicEsQuery
            .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, scenicEsQuery.and, false)
            .addPattern(
              "title.keyword",
              "*" + _this.value + "*",
              scenicEsQuery.and,
              false
            )
            .addSort("weight", scenicEsQuery.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          const scenicEsJsonQuery = JSON.stringify(scenicEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.scenic,
                esJsonQuery: scenicEsJsonQuery,
              })
            )
            .then((response) => {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
        case 2: // 攻略
          const strategyEsQuery = new EsQuery();
          strategyEsQuery
            .addPattern(
              "title.keyword",
              "*" + _this.value + "*",
              strategyEsQuery.and,
              false
            )
            .addStartWith(
              "deptCode",
              _this.DEPT_CODE.DEPTCODE,
              strategyEsQuery.and,
              false
            )
            .addString("kind", "1", strategyEsQuery.and, false)
            // .addSort("sortNum", strategyEsQuery.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          const strategyEsJsonQuery = JSON.stringify(strategyEsQuery.getArray());
          _this.$http
            .post(
              "api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.strList,
                esJsonQuery: strategyEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
        case 3: // 游记
          const travelsEsQuery = new EsQuery();
          travelsEsQuery
            .addPattern(
              "title.keyword",
              "*" + _this.value + "*",
              travelsEsQuery.and,
              false
            )
            .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, travelsEsQuery.and, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.travelList,
                esJsonQuery: travelsEsJsonQuery,
              })
            )
            .then((response) => {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
        // case 4: // 农家乐
        //     const countryEsQuery = new EsQuery()
        //     countryEsQuery
        //         .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, countryEsQuery.and, false)
        //         .addPattern("title", "*" + this.value + "*", countryEsQuery.and, false)
        //         .addSort("weight", countryEsQuery.desc, false)
        //         .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
        //     const countryEsJsonQuery = JSON.stringify(countryEsQuery.getArray())
        //     this.$http.get('/bicQuery?indexName='+this.INDEX_NAME_TYPE.rural+'&esJsonQuery=' + encodeURI(countryEsJsonQuery)).then((response) => {
        //         this.tabsList = this.tabsList.concat(response.data.data)
        //         if (response.data.data.length < this.tabsListPageSize) {
        //             this.infiniteAll = true
        //         }
        //         this.infiniteStatus = false
        //     })
        //     break;
        case 4: // 酒店
          const hotelEsQuery = new EsQuery();
          hotelEsQuery
            // .addString("category", _this.XXCJ_TYPE_CODE.JD, hotelEsQuery.and, false)
            .addPattern("title.keyword", "*" + _this.value + "*", hotelEsQuery.and, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            )
            // .addSort("level", hotelEsQuery.asc, false)
            .addString("deptCode", this.DEPT_CODE.DEPTCODE, hotelEsQuery.and, false);
          const hotelEsJsonQuery = JSON.stringify(hotelEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.hotelList,
                esJsonQuery: hotelEsJsonQuery,
              })
            )
            .then((response) => {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
        case 5: // 美食
          const allXcEsQuery = new EsQuery();
          allXcEsQuery
            .addString("category", _this.XXCJ_TYPE_CODE.MS, allXcEsQuery.and, false)
            .addPattern("title.keyword", "*" + this.value + "*", allXcEsQuery.and, false)
            // .addSort("weight", allXcEsQuery.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            )
            .addString("deptCode", this.DEPT_CODE.DEPTCODE, allXcEsQuery.and, false);
          const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.periphery,
                esJsonQuery: allXcEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;

        case 6: // 新闻
          let newsEsQuery = new EsQuery();
          newsEsQuery
            .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
            .addStartWith("catalogCode", "00000000,1720488224033", newsEsQuery.and, false)
            // .addString("top", 1, newsEsQuery.and, false)
            .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
            .addSort("weight", newsEsQuery.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          let newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.newsList,
                esJsonQuery: newsEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
        case 7: // 新闻
          newsEsQuery = new EsQuery();
          newsEsQuery
            .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
            .addStartWith("catalogCode", "00000000,1720766038703", newsEsQuery.and, false)
            // .addString("top", 1, newsEsQuery.and, false)
            .addPattern("title.keyword", "*" + _this.value + "*", newsEsQuery.and, false)
            .addSort("weight", newsEsQuery.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          newsEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.newsList,
                esJsonQuery: newsEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
          case 8: // 自驾游
          let driving = new EsQuery();
          driving
            .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, driving.and, false)
            // .addStartWith("catalogCode", "00000000,1720488224033", driving.and, false)
            // .addString("top", 1, newsEsQuery.and, false)
            .addPattern("title.keyword", "*" + _this.value + "*", driving.and, false)
            .addSort("weight", driving.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          let drivingEsJsonQuery = JSON.stringify(driving.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.driveCamp,
                esJsonQuery: drivingEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
          case 9: // 新闻
          let agr = new EsQuery();
          agr
            .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, agr.and, false)
            // .addString("top", 1, newsEsQuery.and, false)
            .addPattern("title.keyword", "*" + _this.value + "*", agr.and, false)
            .addSort("weight", agr.desc, false)
            .addPage(
              _this.tabsListPageNo * _this.tabsListPageSize,
              _this.tabsListPageSize
            );
          let agrEsJsonQuery = JSON.stringify(agr.getArray());
          _this.$http
            .post(
              "/api/wtcp-kb/pub/doc/search",
              querystring.stringify({
                indexName: _this.INDEX_NAME_TYPE.rural,
                esJsonQuery: agrEsJsonQuery,
              })
            )
            .then(function (response) {
              _this.tabsList = _this.tabsList.concat(response.data.data);
              if (response.data.data.length < _this.tabsListPageSize) {
                _this.infiniteAll = true;
              }
              _this.infiniteStatus = false;
            });
          break;
      }
    },
    infinite: function () {
      if (this.infiniteAll) {
        return;
      }
      if (this.infiniteStatus) {
        return;
      }

      this.infiniteStatus = true;
      this.tabsListPageNo += 1;
      this.getTabsList();
    },
  },
};
